import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import "./CheckListFamilyPastChoice.css";
import { getServerBaseUrl } from "../../../utils/portConfig";

const CheckListFamilyPastChoice = ({ isOpen, patientId, onClose }) => {
  const [selectedTab, setSelectedTab] = useState("현병력"); // 가족력 과거력 설정
  const [checkedOptions, setCheckedOptions] = useState({ bunmanFamilyHistory: [], bunmanPastHistory: [], bunmanPresentIllness: [] });
  const [bFHData, setBFHData] = useState([]); // 가족력 데이터

  const token = localStorage.getItem("token");
  const id = localStorage.getItem("id");

  useEffect(() => {
    if (isOpen) {
      fetchFamilyHistoryData();
    }
  }, []);

  const fetchFamilyHistoryData = async () => {
    try {
      const response = await axios.get(`${getServerBaseUrl()}/api/v1/checklist/getFPHistory/${patientId}`, { headers: { Authorization: `Bearer ${token}` } });

      if (response.status === 200) {
        const bFHString = response.data.bunmanFamilyHistory[0].bunmanFamilyHistory;
        const bPHString = response.data.bunmanPastHistory[0].bunmanPastHistory;
        const bPreHString = response.data.bunmanPresentIllness[0].bunmanPresentIllness;
        if (bFHString !== null && bPHString !== null && bPreHString !== null) {
          let bfHArray = [];
          if (bFHString.includes(",")) {
            bfHArray = bFHString.split(", ");
          } else {
            bfHArray.push(bFHString);
          }

          let bpHArray = [];
          if (bPHString.includes(",")) {
            bpHArray = bPHString.split(", ");
          } else {
            bpHArray.push(bPHString);
          }

          let bpreHArray = [];
          if (bPreHString.includes(",")) {
            bpreHArray = bPreHString.split(", ");
          } else {
            bpreHArray.push(bPreHString);
          }

          setCheckedOptions({ bunmanFamilyHistory: bfHArray, bunmanPastHistory: bpHArray, bunmanPresentIllness: bpreHArray });
        } else {
          setCheckedOptions({ bunmanFamilyHistory: [], bunmanPastHistory: [], bunmanPresentIllness: [] });
        }
      }
    } catch (error) {
      console.error("가족력 정보를 가져오지 못했습니다: ", error);
    }
  };

  // 탭을 클릭했을 때 호출되는 함수
  const handleTabClick = (tabName) => {
    setSelectedTab(tabName);
  };

  const saveCheckListFPH = async () => {
    if (checkedOptions.bunmanFamilyHistory.length === 0) {
      showWarningAlert("가족력을 선택해 주세요. 없으면 없음을 눌러주세요.");
      return;
    }
    if (checkedOptions.bunmanPastHistory.length === 0) {
      showWarningAlert("과거력을 선택해 주세요. 없으면 없음을 눌러주세요.");
      return;
    }
    if (checkedOptions.bunmanPresentIllness.length === 0) {
      showWarningAlert("현병력을 선택해 주세요. 없으면 없음을 눌러주세요.");
      return;
    }
    try {
      const response = await axios.put(`/api/v1/checklist/updateFPHistory/${patientId}`, checkedOptions, { headers: { Authorization: `Bearer ${token}` } });

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "가족/과거/현재 병력이 등록되었습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        }).then(() => {
          onClose();
        });
      }
    } catch (error) {
      console.error("validation error: ", error);
    }
  };

  const handleCheckboxChange = (optionId, type) => {
    let newCheckedOptionsFam = checkedOptions.bunmanFamilyHistory ? { bunmanFamilyHistory: [...checkedOptions.bunmanFamilyHistory] } : null;
    let newCheckedOptionsPast = checkedOptions.bunmanPastHistory ? { bunmanPastHistory: [...checkedOptions.bunmanPastHistory] } : null;
    let newCheckedOptionsPresent = checkedOptions.bunmanPresentIllness ? { bunmanPresentIllness: [...checkedOptions.bunmanPresentIllness] } : null;

    if (newCheckedOptionsFam !== null && type === "fam") {
      const index = newCheckedOptionsFam.bunmanFamilyHistory.indexOf(optionId);
      if (index !== -1) {
        newCheckedOptionsFam.bunmanFamilyHistory.splice(index, 1);
      } else {
        if (newCheckedOptionsFam.bunmanFamilyHistory[0] === "") {
          newCheckedOptionsFam.bunmanFamilyHistory.splice(index - 1, 1);
          newCheckedOptionsFam.bunmanFamilyHistory.push(optionId);
        } else {
          if (newCheckedOptionsFam.bunmanFamilyHistory.length !== 0 && optionId === "") {
            newCheckedOptionsFam.bunmanFamilyHistory = newCheckedOptionsFam.bunmanFamilyHistory.filter((value) => value === "");
            newCheckedOptionsFam.bunmanFamilyHistory.push(optionId);
          } else {
            newCheckedOptionsFam.bunmanFamilyHistory.push(optionId);
          }
        }
      }
      setCheckedOptions({ ...checkedOptions, ...newCheckedOptionsFam });
    } else if (newCheckedOptionsPresent !== null && type === "present") {
      const index = newCheckedOptionsPresent.bunmanPresentIllness.indexOf(optionId);
      if (index !== -1) {
        newCheckedOptionsPresent.bunmanPresentIllness.splice(index, 1);
      } else {
        if (newCheckedOptionsPresent.bunmanPresentIllness[0] === "") {
          newCheckedOptionsPresent.bunmanPresentIllness.splice(index - 1, 1);
          newCheckedOptionsPresent.bunmanPresentIllness.push(optionId);
        } else {
          if (newCheckedOptionsPresent.bunmanPresentIllness.length !== 0 && optionId === "") {
            newCheckedOptionsPresent.bunmanPresentIllness = newCheckedOptionsPresent.bunmanPresentIllness.filter((value) => value === "");
            newCheckedOptionsPresent.bunmanPresentIllness.push(optionId);
          } else {
            newCheckedOptionsPresent.bunmanPresentIllness.push(optionId);
          }
        }
      }
      setCheckedOptions({ ...checkedOptions, ...newCheckedOptionsPresent });
    } else if (newCheckedOptionsPast !== null && type === "past") {
      const index = newCheckedOptionsPast.bunmanPastHistory.indexOf(optionId);
      if (index !== -1) {
        newCheckedOptionsPast.bunmanPastHistory.splice(index, 1);
      } else {
        if (newCheckedOptionsPast.bunmanPastHistory[0] === "") {
          newCheckedOptionsPast.bunmanPastHistory.splice(index - 1, 1);
          newCheckedOptionsPast.bunmanPastHistory.push(optionId);
        } else {
          if (newCheckedOptionsPast.bunmanPastHistory.length !== 0 && optionId === "") {
            newCheckedOptionsPast.bunmanPastHistory = newCheckedOptionsPast.bunmanPastHistory.filter((value) => value === "");
            newCheckedOptionsPast.bunmanPastHistory.push(optionId);
          } else {
            newCheckedOptionsPast.bunmanPastHistory.push(optionId);
          }
        }
      }
      setCheckedOptions({ ...checkedOptions, ...newCheckedOptionsPast });
    }
  };

  const showWarningAlert = (text) => {
    Swal.fire({
      icon: "warning",
      title: "알림",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };
  //console.log('checkedOptions:::'+JSON.stringify(checkedOptions));
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="체크리스트-가족력/과거력 선택"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "1px solid #ccc",
          background: "white",
          borderRadius: "4px",
          width: "380px",
          height: "163px",
          fontWeight: "400",
          padding: "8px",
        },
      }}
    >
      <div className="tab-area">
        <div className={`tab ${selectedTab === "현병력" ? "selected-tab" : ""}`} onClick={() => handleTabClick("현병력")}>
          현병력
        </div>
        <div className={`tab ${selectedTab === "가족력" ? "selected-tab" : ""}`} onClick={() => handleTabClick("가족력")}>
          가족력
        </div>
        <div className={`tab ${selectedTab === "과거력" ? "selected-tab" : ""}`} onClick={() => handleTabClick("과거력")}>
          과거력
        </div>
      </div>
      {/* bfp: bunman Present & Family & Past */}
      {selectedTab === "현병력" && (
        <div className="bfp-body-container">
          <div className="chklist-choice-container">
            <input type="checkbox" name="choice-illness" id="당뇨" checked={checkedOptions.bunmanPresentIllness.includes("당뇨")} onChange={() => handleCheckboxChange("당뇨", "present")} />
            <label>당뇨</label>
            <input type="checkbox" name="choice-illness" id="" checked={checkedOptions.bunmanPresentIllness.includes("")} onChange={() => handleCheckboxChange("", "present")} />
            <label>없음</label>
          </div>
          <div className="chklist-choice-container"></div>
          <div className="csc-button-container">
            <button onClick={saveCheckListFPH}>저장</button>
            <button onClick={onClose} style={{ backgroundColor: "red" }}>
              닫기
            </button>
          </div>
        </div>
      )}
      {selectedTab === "가족력" && (
        <div className="bfp-body-container">
          <div className="chklist-choice-container">
            <input type="checkbox" name="choice-illness" id="전자간증" checked={checkedOptions.bunmanFamilyHistory.includes("전자간증")} onChange={() => handleCheckboxChange("전자간증", "fam")} />
            <label>전자간증</label>
            <input type="checkbox" name="choice-illness" id="고혈압" checked={checkedOptions.bunmanFamilyHistory.includes("고혈압")} onChange={() => handleCheckboxChange("고혈압", "fam")} />
            <label>고혈압</label>
            <input type="checkbox" name="choice-illness" id="당뇨" checked={checkedOptions.bunmanFamilyHistory.includes("당뇨")} onChange={() => handleCheckboxChange("당뇨", "fam")} />
            <label>당뇨</label>
          </div>
          <div className="chklist-choice-container">
            <input type="checkbox" name="choice-illness" id="신장질환" checked={checkedOptions.bunmanFamilyHistory.includes("신장질환")} onChange={() => handleCheckboxChange("신장질환", "fam")} />
            <label>신장질환</label>
            <input
              type="checkbox"
              name="choice-illness"
              id="자가면역질환"
              checked={checkedOptions.bunmanFamilyHistory.includes("자가면역질환")}
              onChange={() => handleCheckboxChange("자가면역질환", "fam")}
            />
            <label>자가면역질환</label>
            <input type="checkbox" name="choice-illness" id="" checked={checkedOptions.bunmanFamilyHistory.includes("")} onChange={() => handleCheckboxChange("", "fam")} />
            <label>없음</label>
          </div>
          <div className="csc-button-container">
            <button onClick={saveCheckListFPH}>저장</button>
            <button onClick={onClose} style={{ backgroundColor: "red" }}>
              닫기
            </button>
            {/* <button className="red-button" onClick={onClose}>닫기</button> */}
          </div>
        </div>
      )}
      {selectedTab === "과거력" && (
        <div className="bfp-body-container">
          <div className="chklist-choice-container">
            <input
              type="checkbox"
              name="choice-illness"
              id="항문 헤르페스"
              checked={checkedOptions.bunmanPastHistory.includes("항문 헤르페스")}
              onChange={() => handleCheckboxChange("항문 헤르페스", "past")}
            />
            <label>항문 헤르페스</label>
            <input
              type="checkbox"
              name="choice-illness"
              id="고혈압성질환"
              checked={checkedOptions.bunmanPastHistory.includes("고혈압성질환")}
              onChange={() => handleCheckboxChange("고혈압성질환", "past")}
            />
            <label>고혈압성질환</label>
            <input
              type="checkbox"
              name="choice-illness"
              id="만성신장질환"
              checked={checkedOptions.bunmanPastHistory.includes("만성신장질환")}
              onChange={() => handleCheckboxChange("만성신장질환", "past")}
            />
            <label>만성신장질환</label>
          </div>
          <div className="chklist-choice-container">
            <input
              type="checkbox"
              name="choice-illness"
              id="자가면역질환"
              checked={checkedOptions.bunmanPastHistory.includes("자가면역질환")}
              onChange={() => handleCheckboxChange("자가면역질환", "past")}
            />
            <label>자가면역질환</label>
            <input
              type="checkbox"
              name="choice-illness"
              id="만성고혈압"
              checked={checkedOptions.bunmanPastHistory.includes("만성고혈압")}
              onChange={() => handleCheckboxChange("만성고혈압", "past")}
            />
            <label>만성고혈압</label>
            <input type="checkbox" name="choice-illness" id="" checked={checkedOptions.bunmanPastHistory.includes("")} onChange={() => handleCheckboxChange("", "past")} />
            <label>없음</label>
          </div>
          <div className="csc-button-container">
            <button onClick={saveCheckListFPH}>저장</button>
            <button onClick={onClose} style={{ backgroundColor: "red" }}>
              닫기
            </button>
            {/* <button className="red-button" onClick={onClose}>닫기</button> */}
          </div>
        </div>
      )}
    </Modal>
  );
};
export default CheckListFamilyPastChoice;
